export class Controller {

    /** @ngInject */
    constructor($translate, $uibModal) {
        this.$translate = $translate;
        this.$uibModal = $uibModal;
    }

    $onInit() {
    }

    showAutoConfigureSsoModal() {
        this.$uibModal.open({
            component: 'autoConfigureSsoModal',
            resolve: {
                appId: () => this.application.id,
                companyId: () => this.companyId,
                domainName: () => this.application.appDomain.domainName,
            }
        })
    }

    templateUrl() {
        return require(`./configure-sso-${this.$translate.use()}.html`);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/configure-sso/configure-sso.controller.js